<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <v-btn depressed @click="back">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span>
          <div style="display: inline-block" v-if="roleEditUser('pages')">
            Конструктор страницы
          </div>
          <div style="display: inline-block" v-else>Редактирование</div>
          «{{ page.title }}»
        </span>
      </div>
      <div class="buttons-header">
        <v-btn @click="goToAdd" style="width: auto !important" class="button-accept">
          Добавить блок
        </v-btn>
        <v-btn v-if="roleEditUser('pages')" @click="openDialog" style="width: auto !important; margin-left: 32px"
          class="button-action">
          Редактировать
        </v-btn>
      </div>
    </div>

    <div>
      <div class="main-container-subtitle-box">
        <div class="main-container-subtitle-box-text">Блоки</div>
      </div>
      <v-data-table :headers="tableHeaders" :items="page.blocks" item-key="id" :show-select="false"
        :disable-pagination="true" :hide-default-footer="true">
        <template v-slot:body="props">
          <draggable :list="props.items" tag="tbody" :move="checkMove">
            <tr v-for="(item, index) in props.items" :key="index" @click="goToDetail(item)">
              <td>
                <v-icon small style="cursor: pointer"> mdi-menu </v-icon>
              </td>
              <td style="max-width: 100px !important">{{ index + 1 }}</td>
              <td>
                <div class="d-flex align-center" v-if="page">
                  <v-img max-width="30px" :src="getType(item.type, true)"></v-img>
                  <div style="margin-left: 20px">
                    {{ getType(item.type, false) }}
                  </div>
                </div>
              </td>

              <td>
                {{ item.title }}
              </td>
              <td>
                <div v-if="item.transition && item.transition.type == 'url'">
                  Ссылка на внешний ресурс
                </div>
                <div v-if="item.transition && item.transition.type == 'file'">
                  Файл
                </div>
                <div v-if="item.transition && item.transition.type == 'page'">
                  Страница
                </div>
                <div v-if="item.transition && item.transition.type == 'deeplink'">
                  Внутренний раздел
                </div>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
      <v-dialog width="570px" height="auto" persistent v-model="dialog">
        <v-card width="570px" height="auto" class="rounded-0">
          <v-form ref="formFirst">
            <v-card-title class="dialog-title">
              <span class="title">Редактирование страницу</span>
              <v-icon @click="closeDialog">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="dialog-description">
              <v-text-field style="margin-top: 20px" label="Название" required type="text" outlined :rules="rules"
                v-model="copyPage.title"></v-text-field>
              <v-text-field label="Ключ" required type="text" outlined :rules="rules"
                v-model="copyPage.key"></v-text-field>
            </v-card-text>
            <v-card-actions class="dialog-buttons">
              <v-btn style="width: 120px !important" @click="savePage" class="button-accept">
                Сохранить
              </v-btn>
              <v-btn @click="dialogDelete = true" style="width: 120px !important" class="button-accept-outlined" outlined
                color="var(--app-red-1)">
                Удалить
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
        <v-card>
          <v-card-title class="dialog-title">
            <span class="title">Точно хотите удалить страницу?</span>
            <v-icon @click="dialogDelete = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
              Нет
            </v-btn>
            <v-btn @click="deletePage" style="width: 120px" outlined color="var(--app-red-1)">
              Да
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    items: [],
    blocksType: [],
    dialog: false,
    dialogDelete: false,
    timerId: "",

    page: {},
    copyPage: {},
    rules: [(value) => !!value || "Обязательно к заполнению"],
    tableHeaders: [
      {
        text: "",
        sortable: false,
      },
      {
        text: "Порядок отображения",

        sortable: false,
      },
      {
        text: "Вид блока ",
        sortable: false,
      },
      {
        text: "Заголовок ",
        sortable: false,
      },
      {
        text: "Переход ",
        sortable: false,
      },
    ],
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
  }),
  methods: {
    openDialog() {
      this.dialog = true;
      this.copyPage = Object.assign({}, this.page);
    },
    getType(type, src) {
      const obj = this.blocksType.filter((item) => item.key == type);
      if (src) {
        return obj[0].icon;
      } else {
        return obj[0].name;
      }
    },
    getTypeBlocks() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/page/block/type/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.blocksType = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deletePage() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/page", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            pageId: this.page.id,
          },
        })
        .then(() => {
          this.dialogDelete = false;
          this.closeDialog();
          this.back();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    back() {
      this.$router.push({ name: "Constructor" });
    },
    goToAdd() {
      this.$router.push({
        name: "AddBlockConstructor",
        params: { id: this.page.id },
      });
    },
    goToDetail(item) {
      this.$router.push({
        name: "DetailBlockConstructor",
        params: { id: this.page.id, idBlock: item.id },
      });
    },
    getPage() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/page", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            pageId: this.$route.params.id,
          },
        })
        .then((res) => {
          this.page = res.data;
          this.page.blocks.sort(function (a, b) {
            return a.index - b.index;
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    closeDialog() {
      this.dialog = false;
      this.copyPage = {};
      this.$refs.formFirst.reset();
      this.$refs.formFirst.resetValidation();
    },
    savePage() {
      if (this.$refs.formFirst.validate()) {
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/page",
            {
              pageId: this.copyPage.id,
              title: this.copyPage.title,
              key: this.copyPage.key,
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.closeDialog();
            this.getPage();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },

    checkMove(evt) {
      this.page.blocks.map((item) => {
        if (item == evt.draggedContext.element) {
          item.futureIndex = evt.draggedContext.futureIndex + 1;
          return item;
        } else {
          return item;
        }
      });
      let newIndexList = this.page.blocks.map((item) => {
        const newObj = {
          newIndex: item.futureIndex,
          id: item.id,
          oldIndex: item.index,
        };
        return newObj;
      });
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      this.timerId = setTimeout(async () => {
        const newArr = newIndexList.filter((item) => item.newIndex);
        for (let index = 0; index < newArr.length; index++) {
          const element = newArr[index];
          await this.$axios
            .put(
              this.$store.getters.apiAdminPanelV2 + "/page/block/sort",
              {
                blockId: element.id,
                index: element.newIndex,
              },
              {
                headers: {
                  authorization: this.$store.getters.adminPanelHeaderAuth,
                },
              }
            )
            .then(() => { })
            .catch((err) => {
              this.snackbar.isOpen = true;
              this.snackbar.text = err.response.data || err.stack;
            });
        }
        setTimeout(() => {
          this.getPage();
        }, 1000);
      }, 2000);
    },
  },
  created() {
    this.getTypeBlocks();
    this.getPage();
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  .main-container-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .buttons-header {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }

    .main-container-title-box-text {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;
        margin-left: 20px;
      }
    }
  }

  .main-container-subtitle-box {
    padding: 24px;

    .main-container-subtitle-box-text {
      font-size: 24px;
      font-weight: 600;
    }
  }
}

.main-table {
  height: calc(100vh - 195px) !important;
  min-height: calc(100vh - 195px) !important;
  max-height: calc(100vh - 195px) !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>